/* eslint-disable no-template-curly-in-string */
export const antDesingValidateMessages = {
    required: '${label} es requerido',
    types: {
      email: '${label} no es válido.',
    },
    string: {
      range: "${label} debe ser entre ${min} y ${max}"
    },
  };